import { useState } from 'react'
import Button from './Button'
import CalendarDrawerMobile from './CalendarDrawerMobile'
import { CheckIcon } from 'src/iconsV2'

interface SelectMobileProps {
  open: boolean
  onClose: () => void
  onConfirm: (value: string) => void
  defaultValue?: string
  options: {
    value: string;
    label: string;
}[]
}

export const SelectMobile = ({
  open,
  onClose,
  onConfirm,
  defaultValue = 'Month',
  options
}: SelectMobileProps) => {
  const [value, setValue] = useState<string>(defaultValue)

  const handleSelect = (option: string) => {
    setValue(option)
  }

  return (
    <CalendarDrawerMobile title="Filter" open={open} onClose={onClose}>
      <div className="flex flex-col gap-4">
        {options.map((option) => {
          const isSelected = value === option.value
          return (
            <div
              key={option.value}
              className="flex justify-between items-center px-1"
              onClick={() => handleSelect(option.value)}
            >
              <span
                className={`text-sm font-medium ${
                  isSelected ? 'text-[#FFB700]' : 'text-[#1F2937]'
                }`}
              >
                {option.label}
              </span>
              {isSelected && (
                <CheckIcon />
              )}
            </div>
          )
        })}
      </div>

      <div className="mt-6">
        <Button color="primary" fullWidth
          onClick={() => {
          onConfirm(value);
          onClose()
          }}>
          Confirm
        </Button>
      </div>
    </CalendarDrawerMobile>
  )
}
